'use client';

import { Column, Typography } from '@viewup/ui';
import Image from 'next/image';

// Figma 점검 안내 화면(360×800) 값. 앱 테마 토큰(text.primary=gray.900 등)과 값이 달라 Figma hex 를 그대로 쓴다.
const BACKGROUND_COLOR = '#f1f8ff'; // color/background/surface2
const TITLE_COLOR = '#001e40'; // text/primary
const BODY_COLOR = '#576a7c'; // text/secondary

const PARAGRAPHS = [
  '서비스 이용에 불편을 드려 죄송합니다.',
  '보다 안정적인 서비스 제공을 위해\n현재 점검을 진행하고 있습니다.',
  '원활한 서비스를 이용하실 수 있도록\n신속하게 점검을 완료하겠습니다.',
];

export const MaintenancePage = () => {
  return (
    <Column
      alignItems='center'
      css={{ backgroundColor: BACKGROUND_COLOR, minHeight: '100svh', paddingTop: 120 }}
      px={24}
      width='100%'
    >
      <Column alignItems='center' gap={20}>
        <Column alignItems='center' gap={12}>
          <Image alt='VIEWUP' height={17.6} src='/Logo/ViewupWordmark.svg' width={97} />
          <Column alignItems='center' gap={8}>
            <Typography
              as='h1'
              css={{ color: TITLE_COLOR, lineHeight: '44px', textAlign: 'center' }}
              fontType='title2.bold'
            >
              뷰업이 점검중이에요
            </Typography>
            <Column alignItems='center' gap={8}>
              {PARAGRAPHS.map((paragraph) => (
                <Typography
                  css={{
                    color: BODY_COLOR,
                    lineHeight: '24px',
                    textAlign: 'center',
                    whiteSpace: 'pre-wrap',
                  }}
                  fontType='body.regular'
                  key={paragraph}
                >
                  {paragraph}
                </Typography>
              ))}
            </Column>
          </Column>
        </Column>
        <Image alt='' height={200} src='/images/maintenance/boram-crying.png' width={200} />
      </Column>
    </Column>
  );
};
